
import { Vue, Component, Prop } from "vue-property-decorator"
import SelectSubCategories from "@/components/Article/SelectSubCategories.vue"
import { mapState } from "vuex"
import { SubCategory } from "types/subCategory"
import { DataTableHeader } from "vuetify/types"
import { ArticleState } from "src/store/articleType"

interface SubCategoryWithSelect
  extends Pick<SubCategory["data"], "id" | "name" | "category" | "order"> {
  select?: boolean
}

@Component({
  components: { SelectSubCategories },
  computed: {
    ...mapState("article", {
      subCategories: (state) => (state as ArticleState).subCategories,
    }),
  },
})
export default class SubCategories extends Vue {
  @Prop()
  private readonly!: boolean
  private subCategories!: SubCategoryWithSelect[]

  private showDialog = false
  private pagination = {
    sortBy: ["id"],
    sortDesc: [true],
    itemsPerPage: -1,
  }

  get headers(): DataTableHeader[] {
    return [
      { text: "カテゴリー", value: "category.name" },
      { text: "名前", value: "name" },
      { text: "操作", value: "aciton", sortable: false },
    ]
  }

  public show(): void {
    this.showDialog = true
  }

  public hide(): void {
    this.showDialog = false
    const selectSubCategories = this.$refs.selectSubCategories as InstanceType<
      typeof SelectSubCategories
    >
    selectSubCategories.clear()
  }

  public async ok(subCategories: SubCategoryWithSelect[]): Promise<void> {
    if (subCategories.length > 0) {
      const oldSubCategories = Array.from(this.subCategories)
      const newSubCategories = oldSubCategories.concat(subCategories)

      await this.$store
        .dispatch("article/updateArticle", { subCategories: newSubCategories })
        .catch(() => {
          this.hide()
          return
        })
    }
    this.hide()
  }

  public cancel(): void {
    this.hide()
  }

  public async remove(id: number): Promise<void> {
    const subCategories: SubCategoryWithSelect[] = Array.from(
      this.subCategories
    )
    const index = subCategories.findIndex(
      (subCategory) => subCategory.id === id
    )
    subCategories.splice(index, 1)
    await this.$store.dispatch("article/updateArticle", { subCategories })
  }
}
